// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. USE component-icon/src/svgtoreact.sh TO MODIFY
import React from 'react';
import PropTypes from 'prop-types';

var Upload = function Upload(_ref) {
  var className = _ref.className,
      label = _ref.label;
  return (
    /*#__PURE__*/
    React.createElement("svg", {
      className: className,
      "aria-label": label,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16"
    },
    /*#__PURE__*/
    React.createElement("path", {
      d: "M13.636 7.344a2.128 2.128 0 00-3.28-2.588A4.246 4.246 0 002.2 6.416c0 .035 0 .069.005.1A3.455 3.455 0 003.3 13.2h3.27v-3.117H4.476l3.536-3.331 3.536 3.331H9.454V13.2h3.726a2.957 2.957 0 00.456-5.853z"
    }))
  );
};

export default Upload;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-icon/es/reactsvgs/Upload.js
// module id = 1059
// module chunks = 0